import * as React from 'react';
import Axios from 'axios';

import { DebuggerInstance } from '../../shared/debugger';
import { ISimpleResponse } from 'src/App/shared/common-dtos';
import { LoadingCircle } from 'src/App/shared/components/loading-circle.component';

export interface IDtpStepRejectLogoProps {
    logoId: string;
    hash: string;
    baseApiUrl: string;
    onDtpCompleted(): void;
    onBackClick(): void;
}

const msgFileCorrupted: string = 'File is corrupted - file can not be open or is in unknown format.';
const msgFileNotLogo: string = 'File is not logo - file does not contain logo (Excel sheet, ...)';

export interface IDtpStepRejectLogoState {
    selectedMsg: string;
    customMsgSelected: boolean;
    customMsgText: string;
    sendingRequest: boolean;
    requestFailed: boolean;
    showMissingMsgError: boolean;
}

class DtpStepRejectLogoComponent extends React.PureComponent<IDtpStepRejectLogoProps,IDtpStepRejectLogoState> {
    constructor(props: IDtpStepRejectLogoProps) {
        super(props);

        this.state = {
            selectedMsg: msgFileCorrupted,
            customMsgSelected: false,
            customMsgText: '',
            sendingRequest: false,
            requestFailed: false,
            showMissingMsgError: false
        }
    }
    
    private handleSelectedMsgChanged(message: string): void {
        this.setState({
            selectedMsg: message,
            customMsgSelected: false
        })
    }

    private handleCustomMsgSelected() {
        this.setState({
            customMsgSelected: true,
            selectedMsg: this.state.customMsgText
        })
    }

    private async handleSendRequest() {
        // validation of custom message
        if (this.state.customMsgSelected && !this.state.customMsgText) {
            this.setState({
                showMissingMsgError: true
            });
            return;
        } else {
            this.setState({
                sendingRequest: true
            });
        }

        try {
            const apiUrl = this.props.baseApiUrl + `logo-reject/${this.props.logoId}/${this.props.hash}`;
            const responseData = await Axios.post(apiUrl, {
                message: this.state.customMsgSelected ? this.state.customMsgText : this.state.selectedMsg
            });
            const response: ISimpleResponse = responseData.data as ISimpleResponse;

            if (response && response.success) {
                this.setState({
                    sendingRequest: false
                });
                this.props.onDtpCompleted();
            } else {
                DebuggerInstance.error('DtpStepLogoReview.handelAccept - request failed with response:')
                DebuggerInstance.error(response);

                this.setState({
                    sendingRequest: false,
                    requestFailed: true
                });
            }
        } catch (error) {
            DebuggerInstance.error('DtpStepLogoReview.handelAccept - failed with error:')
            DebuggerInstance.error(error);
            this.setState({
                sendingRequest: false,
                requestFailed: true
            });
        }
    }

    private getMessageSelector() {
        return (
            <div>
                <span>File can not be processed - please select reason:</span>
                <div className="message-selection">
                    <label className={'radio-btn-label ' + (this.state.selectedMsg === msgFileCorrupted ? 'radio-btn-label-selected' : '')}>
                        {msgFileCorrupted}
                        <input type="radio"
                            value={msgFileCorrupted}
                            checked={this.state.selectedMsg === msgFileCorrupted}
                            onChange={(e) => this.handleSelectedMsgChanged(e.target.value)}
                        />
                        <span className="checkmark"></span>
                    </label>
                    <label className={'radio-btn-label ' + (this.state.selectedMsg === msgFileNotLogo ? 'radio-btn-label-selected' : '')}>
                        {msgFileNotLogo}
                        <input type="radio"
                            value={msgFileNotLogo}
                            checked={this.state.selectedMsg === msgFileNotLogo}
                            onChange={(e) => this.handleSelectedMsgChanged(e.target.value)}
                        />
                        <span className="checkmark"></span>
                    </label>
                    <label className={'radio-btn-label ' + (this.state.customMsgSelected ? 'radio-btn-label-selected' : '')}>
                        Enter custom message that will be send to user:
                                <input type="radio"
                            value={msgFileNotLogo}
                            checked={this.state.customMsgSelected}
                            onChange={() => this.handleCustomMsgSelected()}
                        />
                        <span className="checkmark"></span>
                        <textarea className="custom-message-area"
                            value={this.state.customMsgText}
                            onChange={(e) => {
                              console.log(e);
                              console.log(e.target.value);
                              this.setState({customMsgText: e.target.value})
                            }}
                            onClick={() => this.handleCustomMsgSelected()}
                        >
                        </textarea>
                        {this.state.showMissingMsgError &&
                            <span className="validation-messsage">*Please fill in message for user</span>
                        }
                    </label>
                </div>
            </div>
        )
    }

    public render() {
        return (
            <div className={'dtp-portal-card'}>
                <div className="title">
                    <span>Step: Reject logo and complete request</span>
                </div>
                <div className="content">
                    <div className="dtp-step-reject-logo-root">
                        {!this.state.sendingRequest && this.getMessageSelector()}
                        {this.state.sendingRequest && (
                            <div className="sending-request">
                                <LoadingCircle />
                                <div>Processing request ...</div>
                            </div>
                        )}
                        {this.state.requestFailed && 
                            <div className="error-message">
                                Failed to complete request due to server error!
                            </div>
                        }
                    </div>
                </div>
                <div className="actions">
                    <button className="action-continue"
                        onClick={() => this.props.onBackClick()}>Back to review</button>
                    <button className="action-continue action-fail"
                        onClick={() => this.handleSendRequest()}>Reject logo &amp; Complete request</button>
                </div>
            </div>
        );
    }
    
}

export const DtpStepRejectLogo = (props: IDtpStepRejectLogoProps) => <DtpStepRejectLogoComponent {...props} />



// WEBPACK FOOTER //
// ./src/App/dtp-portal/cards/dtp-step-reject-logo.component.tsx